import { ReactElement } from 'react';

import { DashboardModuleConfiguration as DashboardModuleConfigurationType } from '@dreryk/egabinet-dashboard-frontend-api';

import { dashboardModuleChipVisitor } from './DashboardModuleConfiguration.utils';
import { NeurologicalModuleChip } from './module/NeurologicalModuleChip';
import { PsychiatricModuleChip } from './module/PsychiatricModuleChip';

type DashboardModuleConfigurationProps = {
   dashboardModuleConfiguration: DashboardModuleConfigurationType | null;
};

export const DashboardModuleConfiguration = (props: DashboardModuleConfigurationProps): ReactElement | null => {
   return dashboardModuleChipVisitor(props.dashboardModuleConfiguration)({
      visitNeurologicalModuleChip: () => <NeurologicalModuleChip />,
      visitPsychiatricModuleChip: () => <PsychiatricModuleChip />,
   });
};
